import { FieldValues } from "react-hook-form";

import { ICountrySACC } from "~/api";
import { useCountriesSACC } from "~/hooks/reference-data";
import { FormAutocomplete } from "~/components/form/FormAutocomplete";

import { FormCountrySelectProps } from "./shared";

export function FormCountrySACCSelect<TFieldValues extends FieldValues = FieldValues>(
  props: FormCountrySelectProps<ICountrySACC | null, TFieldValues>,
) {
  const {
    name,
    control,
    label,
    loading,
    autoHighlight = true,
    disabled,
    ...rest
  } = props;

  const countries = useCountriesSACC();

  return (
    <FormAutocomplete
      {...rest}
      id={name}
      name={name}
      loading={loading || countries.isPending}
      control={control}
      autoHighlight={autoHighlight}
      options={countries?.data ?? []}
      label={label}
      disabled={disabled || loading || countries.isPending}
      getOptionLabel={(country) => country?.sacCountryName ?? ""}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
    />
  );
}
